<!-- components/TermsOfService.vue -->
<template>
    <q-card class="terms-card">
      <q-card-section>
        <div class="text-h4 q-mb-md">Пользовательское соглашение Комбу</div>
        <div class="text-body1 q-mb-md">
          <p><strong>1. Общие положения</strong></p>
          <p>
            1.1. Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между XXX (далее —
            «Компания»), зарегистрированной по адресу XXX, являющейся правообладателем и оператором облачной ERP-системы
            Комбу (далее — «Система»), и физическим или юридическим лицом, использующим Систему (далее —
            «Пользователь»).
          </p>
          <p>
            1.2. Система Комбу — это программное обеспечение, предоставляемое по модели SaaS (Software as a Service),
            предназначенное для автоматизации бизнес-процессов, включая управление договорами, продажами, закупками,
            складским учетом, аналитикой и интеграцией с внешними сервисами.
          </p>
          <p>
            1.3. Использование Системы, включая регистрацию, авторизацию или доступ к любому её функционалу, означает
            безусловное согласие Пользователя с условиями настоящего Соглашения и <a href="/privacy-policy">Политики
              конфиденциальности</a>. В случае несогласия Пользователь обязан немедленно прекратить использование
            Системы.
          </p>
          <p>
            1.4. Соглашение является публичной офертой в соответствии с законодательством XXX (указать страну, например,
            РФ, ст. 437 ГК РФ). Компания оставляет за собой право вносить изменения в Соглашение, уведомляя Пользователя
            через интерфейс Системы или по email.
          </p>

          <p><strong>2. Термины и определения</strong></p>
          <p>
            2.1. <strong>Система</strong> — облачная ERP-система Комбу, доступная через веб-интерфейс по адресу XXX
            или через мобильное приложение, предоставляемое в магазинах приложений (App Store, Google Play).
          </p>
          <p>
            2.2. <strong>Пользователь</strong> — физическое или юридическое лицо, зарегистрированное в Системе,
            использующее её функционал в соответствии с настоящим Соглашением.
          </p>
          <p>
            2.3. <strong>Учетная запись</strong> — совокупность данных, предоставленных Пользователем при регистрации,
            включая логин, пароль и иные идентификаторы, обеспечивающие доступ к Системе.
          </p>
          <p>
            2.4. <strong>Персональные данные</strong> — любая информация, относящаяся к Пользователю, предоставленная им
            добровольно при регистрации или использовании Системы, включая, но не ограничиваясь, ФИО, email, должность,
            данные о компании.
          </p>
          <p>
            2.5. <strong>Контент</strong> — любые данные, загружаемые Пользователем в Систему, включая документы, файлы,
            настройки договоров, аналитические отчеты.
          </p>

          <p><strong>3. Условия использования Системы</strong></p>
          <p>
            3.1. Доступ к Системе предоставляется после регистрации Пользователя и создания Учетной записи. Регистрация
            требует предоставления достоверных данных, включая email и, при необходимости, данные о компании.
          </p>
          <p>
            3.2. Пользователь обязан:
          <ul>
            <li>Предоставлять достоверную и актуальную информацию при регистрации и использовании Системы.</li>
            <li>Обеспечивать конфиденциальность данных Учетной записи, не передавать их третьим лицам.</li>
            <li>Не использовать Систему для незаконных целей, включая нарушение авторских прав, распространение
              вредоносного ПО или несанкционированный доступ к данным других пользователей.</li>
            <li>Соблюдать требования законодательства XXX при использовании Системы.</li>
          </ul>
          </p>
          <p>
            3.3. Пользователь имеет право:
          <ul>
            <li>Использовать функционал Системы в пределах предоставленных прав доступа.</li>
            <li>Настраивать модули Системы (например, управление договорами, аналитика) в соответствии с документацией.
            </li>
            <li>Обращаться в службу поддержки по адресу XXX или через интерфейс Системы.</li>
          </ul>
          </p>
          <p>
            3.4. Пользователю запрещается:
          <ul>
            <li>Копировать, модифицировать или распространять программный код Системы.</li>
            <li>Пытаться получить несанкционированный доступ к данным других пользователей или серверов Компании.</li>
            <li>Использовать Систему для рассылки спама, размещения запрещенного контента или иных действий, нарушающих
              законодательство.</li>
          </ul>
          </p>

          <p><strong>4. Права и обязанности Компании</strong></p>
          <p>
            4.1. Компания обязуется:
          <ul>
            <li>Обеспечивать доступ к Системе в соответствии с условиями Соглашения, за исключением случаев технических
              сбоев или форс-мажора.</li>
            <li>Обеспечивать конфиденциальность персональных данных Пользователя в соответствии с законодательством XXX
              и Политикой конфиденциальности.</li>
            <li>Предоставлять техническую поддержку Пользователям по вопросам работы Системы.</li>
          </ul>
          </p>
          <p>
            4.2. Компания имеет право:
          <ul>
            <li>Приостанавливать или ограничивать доступ Пользователя к Системе при нарушении условий Соглашения.</li>
            <li>Проводить техническое обслуживание Системы, уведомляя Пользователей заранее, если это возможно.</li>
            <li>Вносить изменения в функционал Системы без предварительного уведомления, если это не нарушает основные
              права Пользователя.</li>
          </ul>
          </p>

          <p><strong>5. Лицензия на использование Системы</strong></p>
          <p>
            5.1. Компания предоставляет Пользователю неисключительную, непередаваемую лицензию на использование Системы
            в пределах функционала, доступного через Учетную запись.
          </p>
          <p>
            5.2. Лицензия предоставляется на срок действия Соглашения и может быть ограничена в зависимости от типа
            подписки (бесплатная, платная).
          </p>
          <p>
            5.3. Пользователь не имеет права сублицензировать, передавать или продавать права на использование Системы
            третьим лицам.
          </p>

          <p><strong>6. Обработка персональных данных</strong></p>
          <p>
            6.1. Компания собирает и обрабатывает персональные данные Пользователя, включая ФИО, email, данные о
            компании, IP-адреса, файлы cookie, для следующих целей:
          <ul>
            <li>Обеспечение доступа к Системе.</li>
            <li>Предоставление технической поддержки.</li>
            <li>Аналитика использования Системы для улучшения её функционала.</li>
            <li>Отправка уведомлений о работе Системы или маркетинговых предложений (с согласия Пользователя).</li>
          </ul>
          </p>
          <p>
            6.2. Обработка персональных данных осуществляется в соответствии с законодательством XXX (например, ФЗ-152
            «О персональных данных» в РФ, GDPR в ЕС).
          </p>
          <p>
            6.3. Пользователь имеет право запросить доступ, исправление или удаление своих данных, обратившись по адресу
            XXX.
          </p>
          <p>
            6.4. Компания может передавать данные третьим лицам (например, провайдерам хостинга, аналитическим сервисам)
            только в случаях, предусмотренных Политикой конфиденциальности.
          </p>

          <p><strong>7. Интеграции и сторонние сервисы</strong></p>
          <p>
            7.1. Система может интегрироваться со сторонними сервисами (например, платежные системы, аналитические
            платформы, CRM). Компания не несет ответственности за работу таких сервисов.
          </p>
          <p>
            7.2. Пользователь самостоятельно несет ответственность за настройку интеграций и соблюдение условий
            использования сторонних сервисов.
          </p>

          <p><strong>8. Интеллектуальная собственность</strong></p>
          <p>
            8.1. Все права на Систему, включая программный код, дизайн, документацию, принадлежат Компании или её
            лицензиарам.
          </p>
          <p>
            8.2. Контент, загружаемый Пользователем, остается в его собственности, но Компания получает право на его
            использование в целях предоставления услуг Системы.
          </p>

          <p><strong>9. Ограничение ответственности</strong></p>
          <p>
            9.1. Компания не несет ответственности за:
          <ul>
            <li>Сбои в работе Системы, вызванные действиями третьих лиц, техническими неисправностями или форс-мажорными
              обстоятельствами (стихийные бедствия, военные действия).</li>
            <li>Убытки, понесенные Пользователем в результате неправильного использования Системы или нарушения условий
              Соглашения.</li>
            <li>Содержание данных, загружаемых Пользователем, включая их законность и точность.</li>
          </ul>
          </p>
          <p>
            9.2. Система предоставляется на условиях «как есть» без дополнительных гарантий, кроме тех, что
            предусмотрены законодательством XXX.
          </p>

          <p><strong>10. Порядок разрешения споров</strong></p>
          <p>
            10.1. Все споры, связанные с настоящим Соглашением, разрешаются в досудебном порядке путем переговоров.
          </p>
          <p>
            10.2. В случае невозможности урегулирования спора досудебно он подлежит рассмотрению в суде по месту
            нахождения Компании (XXX) в соответствии с законодательством XXX.
          </p>

          <p><strong>11. Прекращение действия Соглашения</strong></p>
          <p>
            11.1. Соглашение прекращает действие в случае:
          <ul>
            <li>Удаления Пользователем своей Учетной записи.</li>
            <li>Нарушения Пользователем условий Соглашения, что приводит к блокировке доступа.</li>
            <li>Прекращения работы Системы Компанией с уведомлением Пользователей за 30 дней.</li>
          </ul>
          </p>
          <p>
            11.2. При прекращении действия Соглашения Компания удаляет данные Пользователя в соответствии с Политикой
            конфиденциальности.
          </p>

          <p><strong>12. Форс-мажор</strong></p>
          <p>
            12.1. Компания освобождается от ответственности за неисполнение обязательств, вызванное форс-мажорными
            обстоятельствами, включая, но не ограничиваясь, стихийными бедствиями, сбоями в сети Интернет, действиями
            государственных органов.
          </p>

          <p><strong>13. Заключительные положения</strong></p>
          <p>
            13.1. Настоящее Соглашение вступает в силу с момента принятия Пользователем (регистрация, авторизация) и
            действует до момента прекращения использования Системы.
          </p>
          <p>
            13.2. Компания вправе в одностороннем порядке вносить изменения в Соглашение, уведомляя Пользователей через
            интерфейс Системы или по email за 7 дней до вступления изменений в силу.
          </p>
          <p>
            13.3. Контакты для связи: XXX (email, телефон). Техническая поддержка доступна через интерфейс Системы.
          </p>
          <p>
            13.4. Соглашение составлено на русском языке. При наличии перевода на другие языки приоритет имеет
            русскоязычная версия.
          </p>
        </div>
      </q-card-section>
    </q-card>
</template>

<script>
export default {
  name: 'change_password',
  data() {
    return {

    }
  }
}
</script>

<style scoped>
.terms-card {
  max-width: 900px;
  margin: 0 auto;
  background-color: var(--sid-color-surface-0);
  border-radius: var(--sid-radius-surface);
  box-shadow: var(--sid-elevation-2);
}

.text-h4 {
  color: var(--sid-color-primary);
  font-weight: var(--sid-font-weight-medium);
}

.text-body1 {
  line-height: 1.8;
  color: var(--sid-color-text-primary);
}

ul {
  margin-left: 20px;
  margin-bottom: 16px;
}

a {
  color: var(--sid-color-primary);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.q-btn {
  margin: 16px;
}
</style>
